// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./scorecard_export"
import "./demo_qr_copy"

import { mountReactComponents, unmountReactComponents } from "./react/mount"

document.addEventListener("turbo:load", mountReactComponents)
document.addEventListener("turbo:before-cache", unmountReactComponents)
